document.addEventListener("DOMContentLoaded", function () {
    var footerItems = document.querySelectorAll(".footer-expand");
    footerItems.forEach(function (footerItem: any) {
        footerItem.addEventListener("click", function (e: any) {
            e.preventDefault();

            var footerCol = this.closest(".footer-column");
            var footerSubLinks = footerCol.querySelectorAll(".footer-sub-links");

            for (var i = 0; i < footerSubLinks.length; i++) {
                if (!footerSubLinks[i].classList.contains("max-h-7xl")) {
                    footerSubLinks[i].classList.remove("max-h-0");
                    footerSubLinks[i].classList.add("max-h-7xl");
                } else {
                    footerSubLinks[i].classList.remove("max-h-7xl");
                    footerSubLinks[i].classList.add("max-h-0");
                }
            }

            var toggleImg = this.querySelector("img") as HTMLImageElement;
            toggleImg.classList.toggle("transform");
            toggleImg.classList.toggle("rotate-180");
        });
    });
});